export enum WorkStatus {
    Employed = 1,
    Unemployed = 2,
    Student = 3,
    Other = 4
}